// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Ig","articleImagesWrap":"Jg","articleImage":"Kg","singleImage":"Lg"};